import { AppealPaymentMarketplace } from '@/apis/payments/requests.ts'
import { AppealMarketplacePaymentPayload } from '@/apis/providers/types/provider.types.ts'
import { SubmitButton } from '@/app/pages/family_application/student_details/shared/submit-button.tsx'
import {
  AppealPopupProps,
  DecisionFormData,
  FormSchema,
} from '@/app/pages/payments/pages/payment_appeal/_components/marketplace_appeal_popup/types.ts'
import { Button } from '@/common/components/Button.tsx'
import { InfoCircleIcon } from '@/common/icons/general.tsx'
import { Dialog, DialogContent, DialogTrigger } from '@/shad/ui/dialog.tsx'
import { Label } from '@/shad/ui/label.tsx'
import { Textarea } from '@/shad/ui/textarea.tsx'
import { zodResolver } from '@hookform/resolvers/zod'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'

const MarketplaceAppealPopup: React.FC<AppealPopupProps> = ({ payment_id, program_id, success }) => {
  const [open, setOpen] = useState(false)
  const [submitFlagStatus, setSubmitFlagStatus] = useState<'idle' | 'success' | 'error' | 'in_flight' | 'failed' | 'pending'>('idle')

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<DecisionFormData>({
    resolver: zodResolver(FormSchema),
  })

  const handleClose = () => setOpen(false)

  const onSubmit = async (data: DecisionFormData) => {

    const SEND_APPEAL_STATUS = 7
    const payload: AppealMarketplacePaymentPayload = {
      program_id,
      payment_id,
      status: SEND_APPEAL_STATUS,
      applicant_appeal_message: data.applicant_review_comment ?? '',
    };

    setSubmitFlagStatus('in_flight')

    try {
      await AppealPaymentMarketplace(payload);
      setSubmitFlagStatus('success');
      success();
      handleClose();
    } catch (error) {
      console.error('Error submitting data:', error);
      setSubmitFlagStatus('error');
    }

  }

  const handleOpenChange = (isOpen: boolean) => setOpen(isOpen)

  return (
    <div className='flex items-center w-full justify-between'>
      <div className='w-full flex items-center gap-2'>
        <InfoCircleIcon className='text-blue-500 text-2xl' />
        <div>

          <div className='font-medium'>
            Appeal Decision
          </div>
          <div className='text-sm text-gray-600'>
            If you believe this decision is incorrect, you can appeal the decision by providing a reason.
          </div>
        </div>
      </div>
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>
        <Button variant="danger" size="md">
          Appeal
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-3xl">
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">

          <div className="space-y-1">
            <Label>
                Appeal Reason <span className="text-danger ml-1">*</span>
            </Label>
            <Textarea
              {...register('applicant_review_comment')}
              placeholder="Enter your reply"
              rows={6}
            />
            {errors.applicant_review_comment && (
              <p className="text-sm text-red-500">
                {errors.applicant_review_comment.message}
              </p>
            )}
          </div>

          <div className="flex gap-2">
            <SubmitButton
              status={submitFlagStatus}
            />
            <Button
              type="button"
              variant="outline"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
    </div>
  )
}
export default MarketplaceAppealPopup;
